import React from "react";

const NoticeForm = ({ onClose }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 70,
        right: 0,
        width: "400px",
        height: "calc(100vh - 70px)",
        backgroundColor: "#fff",
        boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
        padding: "20px",
        zIndex: 1000,
      }}
    >
      <h5 className="mb-3">Compose Notice</h5>

      <div className="mb-3">
        <label className="form-label">Subject</label>
        <input type="text" className="form-control" placeholder="Enter subject" />
      </div>

      <div className="mb-3">
        <label className="form-label">Message</label>
        <textarea className="form-control" rows="5" placeholder="Write notice here..."></textarea>
      </div>

      <div className="text-end">
        <button className="btn btn-secondary me-2" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">Send</button>
      </div>
    </div>
  );
};

export default NoticeForm;
